module.exports = __webpack_public_path__ + "img/skimmer_driving.687cd52c.svg";